import React from 'react';
// import useBlogs from '../../../Hooks/useBlogs';

const BlogDetails = () => {
	// const [blogs] = useBlogs();
	// console.log(blogs);
	return (
		<section className="py-1 lg:px-0 px-2">
            <div className="container-lg lg:px-28 pb-5 md:text-left text-center">
				<h1 className='text-center text-2xl'>Blog Details</h1>
			</div>
		</section>
	);
};

export default BlogDetails;